/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import { useContext, useEffect, useState } from "react"
import { useDispatch } from "react-redux"

import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import CONSTANT from "../../../constant"
import { Button } from "react-bootstrap"
import {
  GridInitializedContext,
  IsRestoreSearchingContext,
  IsSearchingContext,
  SearchResultContext,
  searchDyTypeContext,
  searchDyFromContext,
  searchDyToContext,
  juchuBusyoCdContext,
  ninusiCdContext,
} from "./SyabanRenrakuhyoContext"
import { T車番連絡表印刷GridItem } from "./SyabanRenrakuhyo"
import {
  積日Bindings,
  卸日Bindings,
  積地Bindings,
  卸地Bindings,
} from "./SyabanRenrakuhyoConstant"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFileAlt } from "@fortawesome/free-regular-svg-icons"
import { TWijmoCellTemplateContext } from "../../../type/wijmoComponents"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import { TSyabanRenrakuhyoPrintReq } from "../../../service/order/syabanRenrakuhyo/TSyabanRenrakuhyo"
import SyabanRenrakuhyoService from "../../../service/order/syabanRenrakuhyo/syabanRenrakuhyoService"
import { AppDispatch } from "../../.."
import dayjs from "dayjs"

/**
 * 車番連絡表印刷grid部
 * @param props
 * @returns
 */
const SyabanRenrakuhyoGrid: React.FC<{
  searchConditionClear?: React.MouseEventHandler<HTMLElement>
  gridId: string
}> = (props) => {
  //#region [context]

  // ロード表示
  const { state: isSearching, setState: setIsSearching } =
    useContext(IsSearchingContext)
  //grid初期化フラグ
  const { state: gridInitialized, setState: setGridInitialized } = useContext(
    GridInitializedContext
  )
  // gridレストア完了フラグ
  const { state: isRestoreSearching, setState: setIsRestoreSearching } =
    useContext(IsRestoreSearchingContext)

  // 検索結果
  const searchResult = useContext(SearchResultContext)

  // 帳票出力条件
  const { state: 検索日区分 } = useContext(searchDyTypeContext)
  const { state: 検索日From } = useContext(searchDyFromContext)
  const { state: 検索日To } = useContext(searchDyToContext)
  const { state: 受注部所コード } = useContext(juchuBusyoCdContext)
  const { state: 荷主コード } = useContext(ninusiCdContext)

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  //#endregion

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<T車番連絡表印刷GridItem>,
    pageSize: number
  ) =>
    new wjCore.CollectionView(data, {
      pageSize,
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    // ヘッダー結合
    mergeHeader(grid)

    grid.refresh()
  }

  /**
   * ヘッダー結合処理
   */
  const mergeHeader = (grid: wjcGrid.FlexGrid) => {
    // header行に一行追加
    var extraRow = new wjcGrid.Row()
    extraRow.allowMerging = true
    var columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    columnHeaders.columns.forEach((c, index) => {
      if (c.binding != null) {
        let setHeaderText = ""
        if (積日Bindings.includes(c.binding)) {
          setHeaderText = "積日"
        } else if (卸日Bindings.includes(c.binding)) {
          setHeaderText = "卸日"
        } else if (積地Bindings.includes(c.binding)) {
          setHeaderText = "積地"
        } else if (卸地Bindings.includes(c.binding)) {
          setHeaderText = "卸地"
        } else {
          setHeaderText = c.header ?? ""
        }
        c.allowMerging = true
        columnHeaders.setCellData(0, index, setHeaderText)
      }
    })

    // ヘッダのみAlignを調整する
    grid.itemFormatter = (panel, r, c, cell) => {
      let setHeaderTextAlign = ""
      if (panel.cellType === wjcGrid.CellType.ColumnHeader) {
        if (r === 0) {
          if (積地Bindings.includes(panel.columns[c].binding ?? "")) {
            setHeaderTextAlign = "left"
          } else if (卸地Bindings.includes(panel.columns[c].binding ?? "")) {
            setHeaderTextAlign = "left"
          }
        }
        cell.style.textAlign = setHeaderTextAlign
      }
    }
  }

  /**
   * 車番連絡表印刷処理
   */
  const printSyabanRenrakuhyo = async () => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    const printCondition: TSyabanRenrakuhyoPrintReq = {
      抽出条件_受注部所コード: 受注部所コード,
      抽出条件_検索日区分: 検索日区分,
      抽出条件_検索日From: 検索日From,
      抽出条件_検索日To: 検索日To,
      抽出条件_荷主コード: 荷主コード,
    }

    try {
      const service = new SyabanRenrakuhyoService({ responseType: "blob" })
      const res = await service.printSyabanRenrakuhyo(printCondition)

      var fileURL = URL.createObjectURL(res)
      window.open(fileURL)
      setTimeout(() => {
        URL.revokeObjectURL(fileURL)
      }, 500)
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  //#endregion

  //#region [baseState]

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(0)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  //#endregion

  //#region [effect]

  //初期表示
  useEffect(() => {
    if (searchResult == null) return
    setGridData({ data: createCollectionView(searchResult, pageSize) })

    flexGrid?.refresh()
  }, [searchResult])

  //#endregion

  return (
    <>
      <FlexGridOuter
        flexGrid={flexGrid}
        setFlexGrid={setFlexGrid}
        gridConstantProperties={CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
        gridData={gridData}
        setGridData={setGridData}
        pageNumber={pageNumber}
        searchConditionClear={props.searchConditionClear}
        gridId={props.gridId}
        isRestoreSearching={isRestoreSearching}
        isEnablePageSize={"hidden"}
        setIsRestoreSearching={setIsRestoreSearching}
        gridInitialized={gridInitialized}
        setGridInitialized={setGridInitialized}
        pageSize={pageSize}
        setPageSize={setPageSize}
        gridInitializedHandler={gridInitializedHandler}
        gridProperties={{
          frozenColumns: 1,
          isReadOnly: false,
          allowMerging: wjcGrid.AllowMerging.ColumnHeaders,
          headersVisibility: wjcGrid.HeadersVisibility.All,
          keyActionTab: wjcGrid.KeyAction.CycleOut,
        }}
        headerComponent={
          <div className="d-flex">
            <Button
              className="btn-done"
              disabled={
                isSearching || searchResult == null || searchResult.length <= 0
              }
              onClick={() => {
                printSyabanRenrakuhyo()
              }}>
              <FontAwesomeIcon icon={faFileAlt} />
              車番連絡表印刷
            </Button>
          </div>
        }>
        <wjrGrid.FlexGridColumn
          binding="受注伝票番号"
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          width={110}
          header="受注No"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="車番"
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          width={70}
          header="車番"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="車種区分名称"
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          width={150}
          header="車種"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="乗務員名"
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          width={120}
          header="運転者"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="荷主依頼番号"
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          width={120}
          header="荷主依頼No"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="積日"
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          width={80}
          header="積日">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<T車番連絡表印刷GridItem>
            ) => {
              let dDate = ""
              if (context.item.積日)
                dDate = dayjs(context.item.積日).format("MM/DD")
              return (
                <>
                  <span>{dDate}</span>
                </>
              )
            }}></wjrGrid.FlexGridCellTemplate>
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="積時間"
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          width={80}
          header="積時間"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="卸日"
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          width={80}
          header="卸日">
          <wjrGrid.FlexGridCellTemplate
            cellType="Cell"
            template={(
              context: TWijmoCellTemplateContext<T車番連絡表印刷GridItem>
            ) => {
              let dDate = ""
              if (context.item.卸日)
                dDate = dayjs(context.item.卸日).format("MM/DD")
              return (
                <>
                  <span>{dDate}</span>
                </>
              )
            }}></wjrGrid.FlexGridCellTemplate>
        </wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="卸時間"
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          width={80}
          header="卸時間"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="積場社名"
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          width={150}
          header="社名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="積場地名"
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          width={100}
          header="地名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="卸場社名"
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          width={150}
          header="社名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="卸場地名"
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          width={100}
          header="地名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="品名"
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          width={150}
          header="品名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="数量"
          isReadOnly={true}
          cssClass="read-only-cell number-col"
          format={"N3"}
          width={70}
          header="数量"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="単位区分名称"
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          width={60}
          header="単位"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="輸送備考"
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          width={250}
          header="輸送用備考"></wjrGrid.FlexGridColumn>
      </FlexGridOuter>
    </>
  )
}

export default SyabanRenrakuhyoGrid
